/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Difference_Stat_ClientsInputs */

const et_difference_stat_clients = /** @type {(inputs: Difference_Stat_ClientsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kliente kuus`)
};

const en_difference_stat_clients = /** @type {(inputs: Difference_Stat_ClientsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clients per month`)
};

/**
* | output |
* | --- |
* | "Clients per month" |
*
* @param {Difference_Stat_ClientsInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const difference_stat_clients = /** @type {((inputs?: Difference_Stat_ClientsInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Difference_Stat_ClientsInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_difference_stat_clients(inputs)
	return en_difference_stat_clients(inputs)
});